/** Product Upsell Custom — deferred selection, color/size matching and unlock reward. */
(function () {
  "use strict";

  var blocks = [];

  function pruneBlocks() {
    blocks = blocks.filter(function (block) { return block && block.isConnected; });
  }

  function reportError(scope, error) {
    console.error("Product Upsell Custom " + scope + " error", error);
  }

  function normalize(value) {
    return String(value || "")
      .trim()
      .toLocaleLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "");
  }

  function readJson(root, selector) {
    var node = root.querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); }
    catch (error) { console.error("Product Upsell Custom JSON error", error); return null; }
  }

  // The main product's variant list is embedded ONCE per section (by
  // product-info.liquid), not once per upsell card, so every card on the
  // same product shares a single read instead of re-parsing an identical
  // copy of its own.
  var mainProductCache = new Map();
  function readMainProduct(block) {
    var sectionId = block.dataset.sectionId || "";
    if (mainProductCache.has(sectionId)) return mainProductCache.get(sectionId);
    var node = document.getElementById("custom-upsell-main-product-" + sectionId);
    var data = null;
    if (node) {
      try { data = JSON.parse(node.textContent); }
      catch (error) { console.error("Product Upsell Custom JSON error", error); }
    }
    mainProductCache.set(sectionId, data);
    return data;
  }

  function productOptions(product) {
    return (product && product.options || []).map(function (option) {
      return typeof option === "string" ? option : option.name;
    });
  }

  function variantOptions(variant) {
    return variant && (variant.options || [variant.option1, variant.option2, variant.option3].filter(function (value) { return value != null; })) || [];
  }

  function optionIndex(product, requested, kind) {
    var names = productOptions(product);
    var target = normalize(requested);
    var exact = names.findIndex(function (name) { return normalize(name) === target; });
    if (exact >= 0) return exact;
    var groups = {
      color: ["color", "colour", "renk", "couleur", "farbe", "colore", "cor"],
      size: ["size", "talla", "beden", "taille", "grosse", "taglia", "tamanho"]
    };
    var group = groups[kind] || [];
    return names.findIndex(function (name) { return group.indexOf(normalize(name)) >= 0; });
  }

  function parseAliases(raw) {
    var result = new Map();
    String(raw || "").replace(/<br\s*\/?\s*>/gi, "\n").split(/\r?\n/).forEach(function (line) {
      var parts = line.split(/\s*(?:=|:)\s*/);
      if (parts.length >= 2 && parts[0].trim() && parts[1].trim()) {
        result.set(normalize(parts[0]), normalize(parts.slice(1).join("=")));
      }
    });
    return result;
  }

  function mainForm(block) {
    var form = document.getElementById(block.dataset.mainFormId || "");
    if (form && form.tagName !== "FORM") form = form.querySelector("form");
    return form || document.querySelector("product-form form, form[data-type='add-to-cart-form']");
  }

  function mainPicker(block) {
    var formId = block.dataset.mainFormId || "";
    var linkedInput = formId && document.querySelector(".simple-variant-picker__radio[form='" + formId + "'], .simple-variant-picker__select[form='" + formId + "']");
    if (linkedInput) return linkedInput.closest(".simple-variant-picker");
    var section = document.getElementById("shopify-section-" + block.dataset.sectionId);
    return (section && section.querySelector(".simple-variant-picker")) || document.querySelector(".simple-variant-picker");
  }

  function pickerValues(block, override) {
    var product = block._mainProduct;
    var picker = mainPicker(block);
    if (!product || !picker) return [];
    return productOptions(product).map(function (_name, index) {
      var position = String(index + 1);
      if (override && String(override.position) === position && override.value != null) return String(override.value);
      var radio = picker.querySelector(".simple-variant-picker__radio[data-option-position='" + position + "']:checked");
      var select = picker.querySelector(".simple-variant-picker__select[data-option-position='" + position + "']");
      return radio ? radio.value : (select ? select.value : "");
    });
  }

  function variantFromPicker(block, override) {
    var picked = pickerValues(block, override);
    if (!picked.some(Boolean)) return null;
    return block._mainProduct.variants.find(function (variant) {
      var options = variantOptions(variant);
      return picked.every(function (value, index) { return !value || normalize(options[index]) === normalize(value); });
    }) || null;
  }

  function mainVariant(block, eventVariant) {
    var product = block._mainProduct;
    if (eventVariant && eventVariant.id && variantOptions(eventVariant).length && product.variants.some(function (variant) { return String(variant.id) === String(eventVariant.id); })) return eventVariant;
    var pickedVariant = variantFromPicker(block, eventVariant && eventVariant.position ? eventVariant : null);
    if (pickedVariant) return pickedVariant;
    var form = mainForm(block);
    var input = form && form.querySelector("input[name='id'], select[name='id']");
    var eventId = eventVariant && (eventVariant.variantId || eventVariant.id);
    var id = eventId || (input && input.value) || new URL(window.location.href).searchParams.get("variant");
    return product.variants.find(function (variant) { return String(variant.id) === String(id); })
      || product.variants.find(function (variant) { return variant.available; })
      || product.variants[0];
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format || "{{amount}}");
    }
    var currency = (document.querySelector("meta[name='currency']") || {}).content || window.Shopify?.currency?.active || "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: "currency", currency: currency }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + " " + currency;
    }
  }

  function imageSource(variant, product) {
    var candidates = [
      variant && variant.featured_image,
      variant && variant.featured_media && variant.featured_media.preview_image,
      variant && variant.image,
      product && product.featured_image
    ];
    for (var index = 0; index < candidates.length; index += 1) {
      var candidate = candidates[index];
      var source = typeof candidate === "string" ? candidate : candidate && (candidate.src || candidate.url);
      if (source) return String(source).replace(/^\/\//, "https://");
    }
    return "";
  }

  function resizedImageSource(source) {
    if (!source) return "";
    return source + (source.indexOf("?") >= 0 ? "&" : "?") + "width=200";
  }

  function hidden(holder, name, value) {
    var input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    holder.appendChild(input);
  }

  // Every custom-upsell card/widget gets ONE items[] index, assigned the
  // first time it successfully resolves its form, and never recomputed
  // after that. The previous approach re-scanned the form for the current
  // max items[N] and used max+1 on every single injection — but blocks
  // reconcile repeatedly (on load, on variant change, on submit), each
  // removing-then-reinserting its own input. When two components' inject
  // calls interleave, that scan can catch the form in a transient state
  // where an already-injected sibling has just been pulled out to be
  // re-added, so both compute the same "next" index and one silently
  // clobbers the other. A stable, once-assigned index makes that
  // impossible regardless of call order or how many times reconcile runs.
  var formIndexCounters = new WeakMap();
  function stableItemIndex(component, form) {
    if (!component.dataset.itemIndex) {
      var next = (formIndexCounters.get(form) || 0) + 1;
      formIndexCounters.set(form, next);
      component.dataset.itemIndex = String(next);
    }
    return component.dataset.itemIndex;
  }

  function removeInputs(owner, form) {
    if (!form) return;
    form.querySelectorAll(".custom-upsell-inputs").forEach(function (node) {
      if (node.dataset.owner === owner) node.remove();
    });
  }

  function injectBlock(block) {
    var form = mainForm(block);
    removeInputs(block.id, form);
    if (!form || block.dataset.selected !== "true" || block.getAttribute("aria-disabled") === "true") return;
    var variantInput = block.querySelector("[data-custom-variant-id]");
    if (!variantInput || !variantInput.value) return;
    var index = stableItemIndex(block, form);
    var holder = document.createElement("div");
    holder.hidden = true;
    holder.className = "custom-upsell-inputs";
    holder.dataset.owner = block.id;
    hidden(holder, "items[" + index + "][id]", variantInput.value);
    hidden(holder, "items[" + index + "][quantity]", "1");
    hidden(holder, "items[" + index + "][properties][_is_custom_upsell]", "true");
    hidden(holder, "items[" + index + "][properties][_linked_to_product]", block.dataset.mainProductId || "");
    if (block.dataset.offerMode === "free") hidden(holder, "items[" + index + "][properties][_is_free_gift]", "true");
    // Persisted as a line-item property (not just read live from this
    // block's own dataset) so the cart drawer — which re-validates unlock
    // rewards against the live cart on every change, see cart.js'
    // reconcileUnlockGiftThresholds — can tell which cart lines still
    // count toward an unlock threshold without needing this product page's
    // DOM to still be around (e.g. the customer is on /cart, not the PDP).
    hidden(holder, "items[" + index + "][properties][_counts_toward_unlock]", block.dataset.countTowardUnlock !== "false" ? "true" : "false");
    form.appendChild(holder);
  }

  function setSelected(block, selected) {
    block.dataset.selected = selected ? "true" : "false";
    block.classList.toggle("is-selected", selected);
    var toggle = block.querySelector("[data-custom-toggle]");
    if (toggle) toggle.checked = selected;
    var button = block.querySelector("[data-custom-select-button]");
    if (button) {
      button.setAttribute("aria-pressed", selected ? "true" : "false");
      var label = button.querySelector("span");
      if (label) label.textContent = selected ? block.dataset.selectedText : block.dataset.defaultButtonText;
    }
    injectBlock(block);
    document.dispatchEvent(new CustomEvent("custom-upsell:selection-change", { detail: { id: block.id, selected: selected } }));
  }

  function matchedSummary(block, values) {
    var mode = block.dataset.summaryMode || "auto";
    if (mode === "both" && values.color && values.size) {
      return (block.dataset.bothTemplate || "[size] · [color]")
        .replace(/\[size\]/gi, values.size)
        .replace(/\[color\]/gi, values.color);
    }
    var useSize = mode === "size" || (mode === "auto" && values.size);
    var value = useSize ? values.size : values.color;
    var template = useSize ? block.dataset.sizeMatchTemplate : block.dataset.colorMatchTemplate;
    return (template || "[value]")
      .replace(/\[value\]/gi, value || "")
      .replace(/\[size\]/gi, values.size || "")
      .replace(/\[color\]/gi, values.color || "");
  }

  function updateDisplay(block, variant, matchValues) {
    var product = block._upsellProduct;
    var idInput = block.querySelector("[data-custom-variant-id]");
    if (idInput) idInput.value = variant.id;
    block._variantId = String(variant.id);

    var image = block.querySelector(".custom-upsell-product-image");
    var src = imageSource(variant, product);
    if (image && src) {
      image.src = resizedImageSource(src);
      image.removeAttribute("srcset");
    }

    var price = block.querySelector("[data-custom-price]");
    var compare = block.querySelector("[data-custom-compare]");
    if (block.dataset.offerMode === "free") {
      if (price) price.textContent = block.dataset.freeText;
      if (compare) compare.textContent = money(variant.price);
    } else {
      if (price) price.textContent = (block.dataset.pricePrefix || "") + money(variant.price);
      if (compare) {
        var hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
        compare.hidden = !hasCompare;
        compare.textContent = hasCompare ? money(variant.compare_at_price) : "";
      }
    }
    var matchText = block.querySelector("[data-custom-match-text]");
    if (matchText) matchText.textContent = matchedSummary(block, matchValues);
    if (block.dataset.selected === "true") injectBlock(block);
  }

  function syncBlock(block, eventVariant) {
    var product = block._upsellProduct;
    var mainProduct = block._mainProduct;
    if (!product || !mainProduct) return;
    var selectedMain = mainVariant(block, eventVariant);
    if (!selectedMain) return;
    block._lastMainVariantId = String(selectedMain.id);
    block._lastMainSelectionKey = variantOptions(selectedMain).map(normalize).join("|");

    var constraints = new Map();
    var matchValues = { color: "", size: "" };
    var matchedIndexes = new Set();
    var manuallyHiddenIndexes = new Set();
    var mainValues = variantOptions(selectedMain);

    if (block.dataset.hideColorPicker === "true") {
      var hiddenColorIndex = optionIndex(product, block.dataset.upsellColorOption, "color");
      if (hiddenColorIndex >= 0) manuallyHiddenIndexes.add(hiddenColorIndex);
    }
    if (block.dataset.hideSizePicker === "true") {
      var hiddenSizeIndex = optionIndex(product, block.dataset.upsellSizeOption, "size");
      if (hiddenSizeIndex >= 0) manuallyHiddenIndexes.add(hiddenSizeIndex);
    }

    function addMatch(enabled, kind, mainName, upsellName, aliasRaw) {
      if (!enabled) return;
      var mainIndex = optionIndex(mainProduct, mainName, kind);
      var upsellIndex = optionIndex(product, upsellName, kind);
      if (upsellIndex >= 0) matchedIndexes.add(upsellIndex);
      if (mainIndex < 0 || upsellIndex < 0) return;
      var raw = mainValues[mainIndex];
      var aliases = parseAliases(aliasRaw);
      constraints.set(upsellIndex, aliases.get(normalize(raw)) || normalize(raw));
      matchValues[kind] = raw || "";
    }

    addMatch(block.dataset.matchColor === "true", "color", block.dataset.mainColorOption, block.dataset.upsellColorOption, block.dataset.colorAliases);
    addMatch(block.dataset.matchSize === "true", "size", block.dataset.mainSizeOption, block.dataset.upsellSizeOption, block.dataset.sizeAliases);

    var optionNodes = Array.prototype.slice.call(block.querySelectorAll("[data-custom-option]"));
    var desired = [];
    optionNodes.forEach(function (node) {
      var index = Number(node.dataset.optionIndex);
      node.hidden = block.dataset.hideAllPickers === "true" || matchedIndexes.has(index) || manuallyHiddenIndexes.has(index);
      var select = node.querySelector("[data-custom-option-select]");
      desired[index] = select && select.value;
    });
    var optionsContainer = block.querySelector("[data-custom-options]");
    if (optionsContainer) optionsContainer.hidden = block.dataset.hideAllPickers === "true" || optionNodes.every(function (node) { return node.hidden; });

    var candidates = product.variants.filter(function (variant) {
      if (variant.available === false) return false;
      var options = variantOptions(variant);
      return Array.from(constraints.entries()).every(function (entry) {
        return normalize(options[entry[0]]) === entry[1];
      });
    });
    var variant = candidates.find(function (candidate) {
      var options = variantOptions(candidate);
      return desired.every(function (value, index) {
        return matchedIndexes.has(index) || !value || normalize(options[index]) === normalize(value);
      });
    }) || candidates[0];

    var wrapper = block.closest("[data-custom-upsell-block]") || block;
    if (!variant) {
      block.setAttribute("aria-disabled", "true");
      wrapper.hidden = block.dataset.hideNoMatch === "true";
      if (block.dataset.selected === "true") setSelected(block, false);
      return;
    }
    block.setAttribute("aria-disabled", "false");
    wrapper.hidden = false;
    var variantValues = variantOptions(variant);
    optionNodes.forEach(function (node) {
      var select = node.querySelector("[data-custom-option-select]");
      var index = Number(node.dataset.optionIndex);
      if (select && variantValues[index] != null) select.value = variantValues[index];
    });
    updateDisplay(block, variant, matchValues);
  }

  var syntheticIdCounter = 0;
  function initBlock(block) {
    if (block.dataset.initialized === "true") return;
    var wrapper = block.closest("[data-custom-upsell-block]");
    if (wrapper) {
      Object.keys(wrapper.dataset).forEach(function (key) {
        if (block.dataset[key] == null || block.dataset[key] === "") block.dataset[key] = wrapper.dataset[key];
      });
    }
    // The .custom-upsell-card element itself has no id attribute in markup.
    // Every place in this file that tracks "which card owns this hidden
    // input" keys off block.id, so with it empty on EVERY card, two toggles
    // on the same product end up sharing the literal same owner string
    // (""). removeInputs("") then matches and deletes both cards' holders
    // indiscriminately, and whichever card injects last is the only one
    // left standing. Borrow the wrapper's real id (or mint one) so each
    // card has a unique, non-empty identity to own its own input.
    if (!block.id) {
      block.id = (wrapper && wrapper.id) ? wrapper.id + "-card" : "custom-upsell-card-" + (++syntheticIdCounter);
    }
    block._upsellProduct = readJson(block, "[data-custom-upsell-product]");
    block._mainProduct = readMainProduct(block);
    if (!block._upsellProduct || !block._mainProduct) {
      block.removeAttribute("data-initialized");
      return;
    }
    block.dataset.initialized = "true";
    blocks.push(block);
    block.querySelectorAll("[data-custom-option-select]").forEach(function (select) {
      select.addEventListener("change", function () { syncBlock(block); });
    });
    var toggle = block.querySelector("[data-custom-toggle]");
    if (toggle) toggle.addEventListener("change", function () { setSelected(block, toggle.checked); });
    var button = block.querySelector("[data-custom-select-button]");
    if (button) button.addEventListener("click", function () { setSelected(block, block.dataset.selected !== "true"); });
    syncBlock(block);
    setSelected(block, block.dataset.preselected === "true");
  }

  function eventVariant(event) {
    return event && event.detail && (event.detail.variant || event.detail) || null;
  }

  function syncAll(event) {
    pruneBlocks();
    var detail = event && event.detail || null;
    var variant = eventVariant(event);
    blocks.forEach(function (block) {
      try {
        var next = variant;
        if ((!next || !next.id) && detail && detail.position && detail.value != null) next = variantFromPicker(block, detail);
        syncBlock(block, next);
      } catch (error) {
        reportError("matching", error);
      }
    });
  }

  function removeUnlock(widget) {
    var form = mainForm(widget);
    removeInputs(widget.id, form);
  }

  function injectUnlock(widget) {
    var form = mainForm(widget);
    removeInputs(widget.id, form);
    if (!form || !widget.classList.contains("is-unlocked")) return;
    var index = stableItemIndex(widget, form);
    var holder = document.createElement("div");
    holder.hidden = true;
    holder.className = "custom-upsell-inputs custom-unlock-inputs";
    holder.dataset.owner = widget.id;
    hidden(holder, "items[" + index + "][id]", widget.dataset.rewardVariantId);
    hidden(holder, "items[" + index + "][quantity]", "1");
    hidden(holder, "items[" + index + "][properties][_is_free_gift]", "true");
    hidden(holder, "items[" + index + "][properties][_is_unlock_gift]", "true");
    hidden(holder, "items[" + index + "][properties][_linked_to_product]", widget.dataset.mainProductId || "");
    // Carried on the line item itself so the cart-side reconciliation in
    // cart.js knows how many qualifying add-ons this specific reward
    // needs, without depending on the unlock-gift widget still being
    // mounted on the page (it lives on the PDP; the customer may be
    // looking at the cart drawer or the /cart page instead).
    hidden(holder, "items[" + index + "][properties][_required_count]", String(Math.max(1, Number(widget.dataset.requiredCount) || 1)));
    form.appendChild(holder);
  }

  function updateUnlock(widget) {
    var required = Math.max(1, Number(widget.dataset.requiredCount) || 1);
    var section = document.getElementById("shopify-section-" + widget.dataset.sectionId) || document;
    var selected = Array.prototype.slice.call(section.querySelectorAll("[data-custom-upsell-card][data-selected='true']"))
      .filter(function (card) {
        var wrapper = card.closest("[data-custom-upsell-block]");
        return card.getAttribute("aria-disabled") !== "true" && (!wrapper || wrapper.dataset.countTowardUnlock !== "false");
      }).length;
    var count = Math.min(selected, required);
    var remaining = Math.max(required - selected, 0);
    var unlocked = remaining === 0;
    widget.classList.toggle("is-unlocked", unlocked);
    var bar = widget.querySelector("[data-unlock-progress]");
    var counter = widget.querySelector("[data-unlock-counter]");
    var status = widget.querySelector("[data-unlock-status]");
    if (bar) bar.style.width = ((count / required) * 100) + "%";
    if (counter) counter.textContent = count + "/" + required;
    if (status) status.textContent = unlocked ? widget.dataset.unlockedText : (widget.dataset.lockedText || "[count]").replace(/\[count\]/gi, remaining);
    if (unlocked) injectUnlock(widget); else removeUnlock(widget);
  }

  // The toggle's own checked state is the one thing that reliably survives
  // an early failed variant match: syncBlock() only forces it unchecked when
  // it flips from matched -> unmatched *after* dataset.selected was already
  // "true". On the very first sync (right at init, before setSelected has
  // run yet) a not-yet-ready main-variant read can mark the card
  // aria-disabled without ever touching the toggle, silently blocking
  // injectBlock() forever after even though the switch still shows on. This
  // re-evaluates the match against the block's real intent (what the toggle
  // shows) and re-affirms selection if it's now eligible.
  function reconcileBlock(block) {
    syncBlock(block);
    var toggle = block.querySelector("[data-custom-toggle]");
    var wantsSelected = toggle ? toggle.checked : block.dataset.selected === "true";
    var eligible = block.getAttribute("aria-disabled") !== "true";
    if (wantsSelected && eligible) {
      setSelected(block, true);
    } else if (!wantsSelected && block.dataset.selected === "true") {
      setSelected(block, false);
    }
  }

  function init(root) {
    pruneBlocks();
    (root || document).querySelectorAll("[data-custom-upsell-card]").forEach(function (block) {
      try { initBlock(block); }
      catch (error) { reportError("initialization", error); }
    });
    (root || document).querySelectorAll("[data-upsell-unlock-gift]").forEach(function (widget) {
      try { updateUnlock(widget); }
      catch (error) { reportError("unlock gift", error); }
    });
  }

  init(document);
  // One follow-up reconciliation pass shortly after init, once the rest of
  // the page (variant picker, etc.) has had a moment to settle, so a
  // preselected toggle that briefly failed its variant match self-heals
  // before the customer ever has to touch it.
  window.setTimeout(function () {
    pruneBlocks();
    blocks.forEach(function (block) {
      try { reconcileBlock(block); }
      catch (error) { reportError("reconcile", error); }
    });
    document.querySelectorAll("[data-upsell-unlock-gift]").forEach(function (widget) {
      try { updateUnlock(widget); }
      catch (error) { reportError("unlock gift", error); }
    });
  }, 300);
  document.addEventListener("DOMContentLoaded", function () { init(document); });
  document.addEventListener("shopify:section:load", function (event) { init(event.target); });
  document.addEventListener("shopify:block:select", function (event) {
    var section = event.target && event.target.closest ? event.target.closest(".shopify-section") : null;
    init(section || document);
  });
  document.addEventListener("simple-variant-picker:variantChange", function (event) { syncAll(event); });
  document.addEventListener("simple-variant-picker:optionChange", function (event) { syncAll(event); });
  window.addEventListener("variantChanged", function (event) { syncAll(event); });
  document.addEventListener("change", function (event) {
    if (event.target.closest && event.target.closest("[data-custom-upsell-card]")) return;
    if (event.target.matches && event.target.matches(".simple-variant-picker__radio, .simple-variant-picker__select, input[name='id'], select[name='id']")) {
      window.setTimeout(function () { syncAll(); }, 0);
    }
  }, true);
  document.addEventListener("custom-upsell:selection-change", function () {
    document.querySelectorAll("[data-upsell-unlock-gift]").forEach(function (widget) {
      try { updateUnlock(widget); }
      catch (error) { reportError("unlock gift", error); }
    });
  });

  // Safety net: a toggle that is preselected on page load (or one whose
  // variant match briefly wasn't ready yet) can end up "selected" in the UI
  // without its hidden items[] input ever having made it into the form. This
  // re-verifies every selected block/widget right before the form is
  // actually submitted, so what the customer sees checked is what gets
  // added to the cart — regardless of what happened earlier on the page.
  // Runs on the capture phase so it lands before product-form.js reads the
  // form's FormData in its own (bubble-phase) submit handler.
  document.addEventListener(
    "submit",
    function (event) {
      var form = event.target;
      if (!form || form.tagName !== "FORM") return;
      pruneBlocks();
      blocks.forEach(function (block) {
        try {
          if (mainForm(block) !== form) return;
          reconcileBlock(block);
        } catch (error) {
          reportError("submit re-sync", error);
        }
      });
      document.querySelectorAll("[data-upsell-unlock-gift]").forEach(function (widget) {
        try {
          if (mainForm(widget) !== form) return;
          updateUnlock(widget);
        } catch (error) {
          reportError("unlock gift", error);
        }
      });
    },
    true,
  );
})();
